// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_rJRqW","content":"index_content_JFiRj"};